"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ToggleButton = ({
  isToggled,
  setIsToggled
}) => {
  const handleToggle = () => {
    setIsToggled(!isToggled);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "flex items-center justify-center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      onClick: handleToggle,
      className: `relative inline-flex items-center h-6 rounded-full w-11 transition-colors focus:outline-none ${isToggled ? 'bg-blue-500' : 'bg-gray-300'}`,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `${isToggled ? 'translate-x-6' : 'translate-x-1'} inline-block w-4 h-4 transform bg-white rounded-full transition-transform`
      })
    })
  });
};
var _default = exports.default = ToggleButton;